import { CheckCircle2, AlertTriangle } from "lucide-react";

export default function PaletteTypeSelector({ value, onChange }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <button
        type="button"
        data-testid="step-type-conforme-btn"
        onClick={() => onChange("P")}
        className={`min-h-[180px] rounded-2xl border-4 p-6 text-left transition-all active:scale-[0.98] ${
          value === "P"
            ? "bg-emerald-600 border-emerald-700 text-white shadow-xl shadow-emerald-700/20"
            : "bg-emerald-50 border-emerald-500 text-emerald-900 hover:bg-emerald-100"
        }`}
      >
        <CheckCircle2 className="w-12 h-12 mb-3" />
        <div className="font-heading font-black text-3xl uppercase leading-none">Conforme P</div>
        <div className="mt-2 text-sm font-semibold opacity-90">
          Catégorie 1 — Destinée à LIOT SAS
        </div>
      </button>

      <button
        type="button"
        data-testid="step-type-declassee-btn"
        onClick={() => onChange("DECLASSEE")}
        className={`min-h-[180px] rounded-2xl border-4 p-6 text-left transition-all active:scale-[0.98] ${
          value === "DECLASSEE"
            ? "bg-rose-600 border-rose-700 text-white shadow-xl shadow-rose-700/25"
            : "bg-rose-50 border-rose-600 text-rose-900 hover:bg-rose-100"
        }`}
      >
        <AlertTriangle className="w-12 h-12 mb-3" />
        <div className="font-heading font-black text-3xl uppercase leading-none">Déclassée</div>
        <div className="mt-2 text-sm font-semibold opacity-90">
          Casserie / Industrie — Non consommable en l'état
        </div>
      </button>
    </div>
  );
}
